<template>
  <span :title="title" class="title">
    {{document.filename}}
    <vue-plyr v-if="document.medium === 'Spoken'" @click.native.stop="" :options="{controls: ['play'], iconUrl: './images/plyr.svg'}">
      <audio :src="`./audio/${document.filename}.mp3`" preload="none"/>
    </vue-plyr>
  </span>
</template>
<script>
  import map from 'lodash/map'
  import reduce from 'lodash/reduce'

  export default {
    props: ['document', 'text', 'elements', 'matches'],
    computed: {
      fields() {
        return {...this.subcorpusFields('Common'), ...this.subcorpusFields(this.document.subcorpus)}
      },
      title() {
        return map(this.fields, (v, k) => `${k}: ${v || ''}`).join('\n')
      }
    },
    methods: {
      subcorpusFields(subcorpus) {
        return reduce(this.$ncsConfig.corefl.fields[subcorpus], (result, field) => {
          result[this.$t(`result.context.header.document.${field}`)] = this.document[field] || ''
          return result
        }, {})
      }
    }
  }
</script>
<style lang="scss">
  .kwic-header {
    .title {
      display: inline-flex;

      .plyr {
        margin: 0 5px 0 5px;
        min-width: 0;

        .plyr__controls {
          padding: 0;
        }
      }
    }
  }
</style>